import { useField } from 'formik'
import { FC, useMemo } from 'react'

import { DatePicker, DatePickerProps } from './DatePicker'

type DatePickerFieldProps = Omit<DatePickerProps<false>, 'onChange' | 'onBlur'> & {
  name: string
  showTimeInput?: boolean
  disabled?: boolean
  isClearable?: boolean
  variant?: 'outline' | 'solid'
  onChange?: (date?: string) => void
}

const DatePickerInputField: FC<DatePickerFieldProps> = ({ name, onChange, ...props }) => {
  const [field, , helper] = useField(name)

  const selected = useMemo(() => field.value, [field.value])

  const handleClear = () => {
    helper.setValue(undefined)
    onChange?.(undefined)
  }

  const handleChange = (date: string) => {
    helper.setValue(date)
    onChange?.(date)
  }

  return (
    <DatePicker
      isClearable
      selected={selected}
      onChange={handleChange}
      onClear={handleClear}
      {...props}
    />
  )
}

export type { DatePickerFieldProps }

export { DatePickerInputField }
